import {
  createTrackingErrorData,
  trackErrorWrapper,
} from './newRelicTrackingUtils';
import { BUY_IT_AGAIN_ERROR } from '../../constants/newRelic';

const FETCH_ORDER_ERROR = 'orders-ui-fetch-order-error';
const FETCH_FULFILLMENT_HISTORY_ERROR =
  'orders-ui-fetch-fulfillment-history-error';

/**
 * An error occurred when fetching an order
 * @param {Error} error - The error object
 * @return {void} - calls trackErrorWrapper
 */
export const trackFetchOrderError = (error: Error, orderId?: string) => {
  let additionalData = {};
  if (orderId) {
    additionalData = { orderId };
  }
  const errorData = createTrackingErrorData(
    FETCH_ORDER_ERROR,
    error,
    additionalData
  );
  trackErrorWrapper(error, errorData);
};

/**
 * Report a metric whenever a call to retrieve fulfillment tracking fails
 * @param {Error} error - The error object
 * @param {object} additionalData - Additional data to be included on the event
 * @return {void} - calls trackErrorWrapper
 */
export const trackGetOrderFulfillmentHistoryError = (
  error: Error,
  additionalData: object = {}
) => {
  const errorData = createTrackingErrorData(
    FETCH_FULFILLMENT_HISTORY_ERROR,
    error,
    additionalData
  );
  trackErrorWrapper(error, errorData);
};

/**
 * The call to fetch reorderable items for "Buy It Again" failed
 * @param {object} error
 * @param {object} additionalData Additional data to include in the tracking event.
 * @returns {void} - calls trackErrorWrapper
 */
export const trackFetchBuyItAgainItemsFail = (
  error: Error,
  additionalData: object
) => {
  const errorData = createTrackingErrorData(
    BUY_IT_AGAIN_ERROR,
    error,
    additionalData
  );
  trackErrorWrapper(error, errorData);
};
